import React from 'react';
import { Image } from 'antd';
import logo from '../Assets/logo.png';
import { ThreeDots } from 'react-loader-spinner';

const CustomLazyLoading = () => {
    // Check the current URL
    if (typeof window !== 'undefined' && window.location.pathname.includes('/stories')) {
        return null; // hide loader on /stories route
    }

    return (
        <div style={{ height: '100vh', display:"flex", justifyContent:"center", alignItems:"center" }}>
            <div className='splashing'>
                <Image preview={false} src={logo} height={30} width={30} />
                <div className='mx-4'>
                    <ThreeDots
                        visible={true}
                        height="80"
                        width="80"
                        color="#8B0000"
                        radius="9"
                        ariaLabel="three-dots-loading"
                    />
                </div>
            </div>
        </div>
    );
}

export default CustomLazyLoading;
